/**
 * A quiet text button: 13px, 32px tall, with the toolbar buttons' hover. On a
 * touch screen an invisible box 6px above and below makes the tap area 44px.
 * Used by the player inspector's cards, such as "Send now" and "Load more".
 */
export const QUIET_BUTTON_CLASS =
    "text-muted-foreground hover:text-foreground hover:bg-foreground/[0.06] focus-visible:ring-ring relative h-8 shrink-0 rounded-lg px-2.5 text-[13px] focus-visible:outline-none focus-visible:ring-1 disabled:pointer-events-none disabled:opacity-50 pointer-coarse:after:absolute pointer-coarse:after:inset-x-0 pointer-coarse:after:-inset-y-1.5 pointer-coarse:after:content-['']";
